import styled from "styled-components";

interface BenefitLabelProps {
  fontWeight?: string;
}

interface IconProps {
  widthStyle?: string;
  heightStyle?: string;
  borderRadius?: string;
}

interface LeftSectionProps {
  width?: string;
  height?: string;
}

interface RightSectionProps {
  width: string;
  padding: string;
}

export const LeftSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: ${({ width }: LeftSectionProps) => width};
  height: ${({ height }: LeftSectionProps) => height};
  padding: 40px 32px 40px 32px;
  background-color: rgba(136, 0, 255, 0.24);
`;

export const RightSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: ${({ width }: RightSectionProps) => width};
  padding: ${({ padding }: RightSectionProps) => padding};
`;

export const Image = styled.img`
  width: ${({ widthStyle }: IconProps) => widthStyle};
  height: ${({ heightStyle }: IconProps) => heightStyle};
  border-radius: ${({ borderRadius }: IconProps) => borderRadius};
  max-width: ${({ widthStyle }: IconProps) => widthStyle};
  max-height: ${({ heightStyle }: IconProps) => heightStyle};
`;

export const DialogTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const DialogTitle = styled.p`
  font-weight: 500;
  font-size: 32px;
`;

export const BenefitsMainContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #f5f3f6;
  gap: 24px;
  padding: 32px 16px;
  border-radius: 8px;
`;

export const BenefitContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const BenefitLabel = styled.p`
  font-family: 'DIN';
  font-style: normal;
  font-size: 18px;
  font-weight: ${({ fontWeight }: BenefitLabelProps) => fontWeight};
`;

export const BenefitListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
